/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface SetMyFacilityNotificationAsRead$Params {
  facilityId: number;
  notificationId: number;
}

export function setMyFacilityNotificationAsRead(http: HttpClient, rootUrl: string, params: SetMyFacilityNotificationAsRead$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, setMyFacilityNotificationAsRead.PATH, 'put');
  if (params) {
    rb.path('facilityId', params.facilityId, {});
    rb.path('notificationId', params.notificationId, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

setMyFacilityNotificationAsRead.PATH = '/api/notification/{notificationId}/{facilityId}/markAsRead';
